import Vue from "vue";
import { randomId } from "@/utils/filters";
import i18n from "@/i18n";

export const state = {
    snackbar: null
};
export const actions = {
    UPDATE_SNACKBAR({ commit }, value) {
        commit("SET_MESSAGE", {
            key: "snackbar",
            value: { id: randomId(), dismiss: true, ...value }
        });
    },
    UPDATE_ERROR_SNACKBAR({ dispatch }, err) {
        const { code } = err?.response?.data || {};
        const e = i18n.t("error");
        const message = e[code] || `${e.unknown} - ${code}`;
        dispatch("UPDATE_SNACKBAR", { message, error: true });
    }
};
export const mutations = {
    SET_MESSAGE(state, { key, value }) {
        Vue.set(state, key, value);
    }
};
